/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 10:37:00
 * @Description: file content
 */ 
import React, { Component } from 'react';

import classNames from 'classnames';
import Button from '../Button';
import { getMultiLang } from '@platform/api';

require('./index.less');

/**
 * @namespace EmptyAreaTip
 */

/**
 * EmptyAreaTip组件的参数描述
 * @memberof EmptyAreaTip
 * @component EmptyAreaTip
 * @property {ReactNode|string} content - 自定义空状态提示内容，有两个预置提示，可以通过type类设置
 * @property {string} [type = desc]  - 空状态提示类型，通过类型加载预置提示，值有 ['desc', 'btn']
 * @property {string} desc - 预置类型的内容描述
 * @property {function(e): null} onClick - 预置提示里按钮的点击事件回调
 */

class EmptyAreaTip extends Component {

    static defaultProps = {
        content: '',
        type: 'desc', // desc btn
        desc: '',
        onClick: null,

    }

    constructor(props) {
        super(props);
        this.state = {
            show: true,
            json: {
                ea0001: '请先新增左树',
                ea0002: '请选择业务单元&业务属性',
                ea0003: '新增',
            },
            LangData: null,
        };
    }

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'ea_tip', callback });
    }

    getContent() {
        let { content, type, onClick, desc } = this.props,
            { json } = this.state;

        if (content) {
            return content;
        }

        switch (type) {
            case 'btn':
                content = (
                    <div className="ea-tip">
                        <i className="ea-tip-img" />
                        <p className="ea-tip-desc">{`${desc || json.ea0001}`}</p>
                        <Button fieldid="add" onClick={onClick} >{json.ea0003}</Button>
                    </div>
                );
                break;
            case 'desc':
            default:
                content = (
                    <div className="ea-tip">
                        <i className="ea-tip-img" />
                        <p className="ea-tip-desc">{`${desc || json.ea0002}`}</p>
                    </div>
                );
                break;
        }

        return content;
    }

    render() {
        let { show } = this.props;
        return (
            <div className={classNames('ea-tip-wapper', { 'ea-tip-hidden': !show })}>
                {this.getContent()}
            </div>
        );
    }
}

export default EmptyAreaTip;